import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';

import css from './RangeSelectFilter.module.css';

// RANGE-SELECT-01 (3b): filtro Desde–Hasta con dos selects (estilo
// idealista) para campos long. Emite un rango "min,max" sobre el query
// param recibido; cualquiera de los dos extremos puede omitirse
// ("min," / ",max"). Ambos vacíos → null (URL limpia, filtro inactivo).
//
// Sin estado local: la URL es la fuente de verdad (initialValues) y cada
// cambio emite onSubmit inmediatamente, igual que el resto de filtros
// custom de la sidebar. Señal de activo: título en verde (labelActive),
// la convención del sprint de filtros.

const parseInitial = raw => {
  if (raw == null || raw === '') return ['', ''];
  const [min = '', max = ''] = `${raw}`.split(',');
  return [min, max];
};

const RangeSelectFilter = props => {
  const intl = useIntl();
  const {
    label,
    queryParamNames,
    initialValues,
    onSubmit,
    fromOptions,
    toOptions,
  } = props;

  const queryParam = Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
  const raw = initialValues?.[queryParam];
  const [minVal, maxVal] = parseInitial(raw);
  const isActive = minVal !== '' || maxVal !== '';

  const emit = (nextMin, nextMax) => {
    const value = nextMin === '' && nextMax === '' ? null : `${nextMin},${nextMax}`;
    onSubmit({ [queryParam]: value });
  };

  const fromLabel = intl.formatMessage({ id: 'RangeSelectFilter.from' });
  const toLabel = intl.formatMessage({ id: 'RangeSelectFilter.to' });

  return (
    <div className={css.root}>
      <div className={css.filterHeader}>
        <p className={classNames(css.label, { [css.labelActive]: isActive })}>{label}</p>
      </div>
      <div className={css.selectsRow}>
        <div className={css.selectWrapper}>
          <span className={css.selectLabel}>
            <FormattedMessage id="RangeSelectFilter.from" />
          </span>
          <select
            className={classNames(css.select, { [css.selectPlaceholder]: minVal === '' })}
            value={minVal}
            onChange={e => emit(e.target.value, maxVal)}
            aria-label={`${label}: ${fromLabel}`}
          >
            <option value="">{intl.formatMessage({ id: 'RangeSelectFilter.noMin' })}</option>
            {fromOptions.map(opt => (
              <option
                key={opt.value}
                value={opt.value}
                disabled={maxVal !== '' && Number(opt.value) > Number(maxVal)}
              >
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className={css.selectWrapper}>
          <span className={css.selectLabel}>
            <FormattedMessage id="RangeSelectFilter.to" />
          </span>
          <select
            className={classNames(css.select, { [css.selectPlaceholder]: maxVal === '' })}
            value={maxVal}
            onChange={e => emit(minVal, e.target.value)}
            aria-label={`${label}: ${toLabel}`}
          >
            <option value="">{intl.formatMessage({ id: 'RangeSelectFilter.noMax' })}</option>
            {toOptions.map(opt => (
              <option
                key={opt.value}
                value={opt.value}
                disabled={minVal !== '' && Number(opt.value) < Number(minVal)}
              >
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default RangeSelectFilter;
